// extracted by mini-css-extract-plugin
export default {"ConfirmButton":"ConfirmButton_ConfirmButton__AHNyt"};